export enum QuantitativeEvaluationType {
  SelfDefinition,
  Point,
}
